
import {
	activityStatusChannel,
	channelName,
	chatNotifications,
	addTeamNoteKey
} from '../../networking/urlEndPoints'

import { fetchAllCommentLists } from '../../services/actions/posts/postCommentsListsActions';
import { fetchPharmacyWallLists } from '../../services/actions/posts/pharmacyWallPostListsActions';
import { fetchAllCommentReplyLists } from '../../services/actions/posts/postCommentReplyListActions';


import { chatChannelName } from '../../networking/urlEndPoints';
import { getAllChatMessages } from '../../services/actions/chat/getChatMessagesActions';
import { fetchAllRecentChats } from '../../services/actions/chat/recentChatsListsActions';

import { fetchTeamNotesMessage } from '../../services/actions/pharmacy/other';
import * as pharmacyTeamNotes from '../../services/actions/pharmacy/other';
import { authPharmacyPermissions } from '../../services/actions/auth/authPermissions';
import { SyncPacmedProcessing } from '../../services/reducers/pharmacy/pacaking/blisterPackaging';
import { FetchTotalMissedRxCount } from '../../services/reducers/pharmacy/pacaking/packaging';
import { CheckLogsExists } from '../../services/reducers/pharmacy/other/commonReducerForInitalData';

import * as images from '../../assets/images/index'
import {
	GetAccountabilityFinalReport, actionTypes,
	createAction,
	FetchNewRxList
} from '../../services/reducers/pharmacy/accountibility/accountibilityNewRx';
import { toast } from 'react-toastify';
import { ablyConnectionManager } from './ablyConnectionManager';
import { showBrowserNotification } from './browserNotification';
import { subscribeRealtimeEvent } from '../../services/realtime/realtimeSocket';

// Helper to create a cleanup wrapper that tracks subscriptions
const createSubscriptionWrapper = (subscriptionIds) => {
	return {
		close: () => {
			if (Array.isArray(subscriptionIds)) {
				subscriptionIds.forEach(id => ablyConnectionManager.unsubscribe(id));
			} else if (subscriptionIds) {
				ablyConnectionManager.unsubscribe(subscriptionIds);
			}
		}
	};
};

const createCombinedSubscriptionWrapper = (...subscriptions) => ({
	close: () => {
		subscriptions.filter(Boolean).forEach((subscription) => {
			if (typeof subscription.close === 'function') {
				subscription.close();
			}
		});
	},
});

export const subscribeToAblyChannels = (
	pharmacyId,
	dispatch,
	setLoading,
	setAppendedCommentsValue,
	setCommentReplyLoader,
	setAppendedCommentReplyValue,
	openPostId,
	commentReplyId) => {

	if (!pharmacyId) {
		console.warn('No pharmacyId provided for Ably subscription');
		return null;
	}

	const channel = ablyConnectionManager.getChannel(channelName);
	if (!channel) return null;

	const postCommentChannel = `post-comment-${pharmacyId}`;
	const postCommentReplyChannel = `post-comment-reply-${pharmacyId}`;

	// Use stable IDs based on channel + event name, not timestamps
	const subscriptionId1 = `${channelName}-${postCommentChannel}`;
	const subscriptionId2 = `${channelName}-${postCommentReplyChannel}`;

	const callback1 = (message) => {
		if (message?.name === postCommentChannel) {
			dispatch(fetchAllCommentLists(setLoading, setAppendedCommentsValue, openPostId));
			dispatch(fetchPharmacyWallLists());
		}
	};

	const callback2 = (message) => {
		if (message?.name === postCommentReplyChannel) {
			dispatch(fetchAllCommentReplyLists(setCommentReplyLoader, setAppendedCommentReplyValue, commentReplyId));
		}
	};

	ablyConnectionManager.subscribe(channelName, postCommentChannel, callback1, subscriptionId1);
	ablyConnectionManager.subscribe(channelName, postCommentReplyChannel, callback2, subscriptionId2);

	return createSubscriptionWrapper([subscriptionId1, subscriptionId2]);
}

export const subscribeGroupMessages = (group_id,
	setChatMessageList,
	setChatMessages,
	playMessageSound,
	profileData, dispatch) => {

	if (!group_id) {
		console.warn('No group_id provided for Ably subscription');
		return null;
	}

	const channel = ablyConnectionManager.getChannel(chatChannelName);
	if (!channel) return null;

	const sendChatMessages = `message-group-${group_id}`;
	const subscriptionId = `${chatChannelName}-${sendChatMessages}`;

	const callback = async (message) => {
		if (message?.name === sendChatMessages) {
			await getAllChatMessages(message?.data?.message_id, setChatMessageList, setChatMessages, playMessageSound, profileData, dispatch)
		}
	};

	ablyConnectionManager.subscribe(chatChannelName, sendChatMessages, callback, subscriptionId);
	const realtimeSubscription = subscribeRealtimeEvent(sendChatMessages, callback);
	return createCombinedSubscriptionWrapper(createSubscriptionWrapper(subscriptionId), realtimeSubscription);
}

export const subscribeUserStatus = (pharmacyId, dispatch) => {

	if (!pharmacyId) {
		console.warn('No pharmacyId provided for Ably subscription');
		return null;
	}

	const channel = ablyConnectionManager.getChannel(activityStatusChannel);
	if (!channel) return null;

	const activityStatusChannelss = `message-for-${pharmacyId}`;
	const subscriptionId = `${activityStatusChannel}-${activityStatusChannelss}`;

	const callback = async (message) => {
		if (message?.name === activityStatusChannelss) {
			dispatch(fetchAllRecentChats())
		}
	};

	ablyConnectionManager.subscribe(activityStatusChannel, activityStatusChannelss, callback, subscriptionId);
	const realtimeSubscription = subscribeRealtimeEvent(activityStatusChannelss, callback);
	return createCombinedSubscriptionWrapper(createSubscriptionWrapper(subscriptionId), realtimeSubscription);
}

export const subscribePostLists = (pharmacyId,
	dispatch,
	setWallListLoading) => {

	if (!pharmacyId) {
		console.warn('No pharmacyId provided for Ably subscription');
		return null;
	}

	const channel = ablyConnectionManager.getChannel(channelName);
	if (!channel) return null;

	const eventName = `wall-post-${pharmacyId}`;
	const subscriptionId = `${channelName}-${eventName}`;

	const callback = (message) => {
		if (message?.name === eventName) {
			dispatch(fetchPharmacyWallLists(setWallListLoading))
		}
	};

	ablyConnectionManager.subscribe(channelName, eventName, callback, subscriptionId);
	return createSubscriptionWrapper(subscriptionId);
}

export const subScribeChatNotifications = (pharmacyId,
	userId,
	dispatch,
	playMessageSound) => {

	if (!pharmacyId || !userId) {
		console.warn('Missing pharmacyId or userId for chat notifications');
		return null;
	}

	const channel = ablyConnectionManager.getChannel(chatNotifications);
	if (!channel) return null;

	const messageNotification = `message-notification-${pharmacyId}-${userId}`;
	const subscriptionId = `${chatNotifications}-${messageNotification}`;

	const callback = (message) => {
		dispatch(fetchAllRecentChats())
		if (typeof playMessageSound === 'function') {
			playMessageSound()
		}
		enableNotifications(message?.data?.title, message?.data?.body)
	};

	ablyConnectionManager.subscribe(chatNotifications, messageNotification, callback, subscriptionId);
	const realtimeSubscription = subscribeRealtimeEvent(messageNotification, callback);
	return createCombinedSubscriptionWrapper(createSubscriptionWrapper(subscriptionId), realtimeSubscription);
}

const enableNotifications = (title, body) => {
	showBrowserNotification(title, {
		body,
		icon: images.oatrx_logo,
	});
}

export const subScribeTeamNotes = (pharmacyId,
	dispatch, setLoading, profileData
) => {

	if (!pharmacyId) {
		console.warn('No pharmacyId provided for Ably subscription');
		return null;
	}

	const channel = ablyConnectionManager.getChannel(addTeamNoteKey);
	if (!channel) return null;

	const messageNotification = `message-team-notes-${pharmacyId}`;
	const subscriptionId = `${addTeamNoteKey}-${messageNotification}`;

	const callback = (message) => {
		if (message?.name === messageNotification) dispatch(fetchTeamNotesMessage())
		if (message?.data?.user_id === profileData?.user_id) {
			if (typeof setLoading === 'function') {
				setLoading(false)
			}
		} else {
			if (typeof setLoading === 'function') {
				setLoading(true)
			}
		}
	};

	ablyConnectionManager.subscribe(addTeamNoteKey, messageNotification, callback, subscriptionId);
	const realtimeSubscription = subscribeRealtimeEvent(messageNotification, callback);
	return createCombinedSubscriptionWrapper(createSubscriptionWrapper(subscriptionId), realtimeSubscription);
}

export const subscribeAddChatGroupNotification = (pharmacyId,
	dispatch,
) => {

	if (!pharmacyId) {
		console.warn('No pharmacyId provided for Ably subscription');
		return null;
	}

	const channelName = 'oat-pharmacy-common-group-channel';
	const channel = ablyConnectionManager.getChannel(channelName);
	if (!channel) return null;

	const messageNotification = `message-common-group-${pharmacyId}`;
	const subscriptionId = `${channelName}-${messageNotification}`;

	const callback = (message) => {
		if (message && message.data && message.data.user_id) {
			dispatch(fetchAllRecentChats())
		}
	};

	ablyConnectionManager.subscribe('oat-pharmacy-common-group-channel', messageNotification, callback, subscriptionId);
	const realtimeSubscription = subscribeRealtimeEvent(messageNotification, callback);
	return createCombinedSubscriptionWrapper(createSubscriptionWrapper(subscriptionId), realtimeSubscription);
}

// const chatGroupNotification = (title, body) => {
// 	if (Notification.permission === 'granted') {
// 		new Notification(title, {
// 			body: 'Added to a group',
// 			icon: images.oatrx_logo,
// 		});
// 	}
// }


export const subscribePharmacyRolesAndPermissions = (pharmacyId,
	dispatch,
) => {
	if (!pharmacyId) {
		console.warn('No pharmacyId provided for Ably subscription');
		return null;
	}

	const channelName = 'pharmacy-user-permission';
	const channel = ablyConnectionManager.getChannel(channelName);
	if (!channel) return null;

	const messageNotification = `message-pharmacy-permissions-${pharmacyId}`;
	const subscriptionId = `${channelName}-${messageNotification}`;

	const callback = (message) => {
		dispatch(authPharmacyPermissions())
	};

	ablyConnectionManager.subscribe('pharmacy-user-permission', messageNotification, callback, subscriptionId);
	return createSubscriptionWrapper(subscriptionId);
}

export const subscribeSyncBlisterPackMedRecords = (pharmacyId,
	dispatch,
	user_Id
) => {
	if (!pharmacyId || !user_Id) {
		console.warn('Missing pharmacyId or user_Id for Ably subscription');
		return null;
	}

	const channelName = 'pacmed-sync-channel';
	const channel = ablyConnectionManager.getChannel(channelName);
	if (!channel) return null;

	const eventName = `progress-${pharmacyId}-${user_Id}`;
	const subscriptionId = `${channelName}-${eventName}`;

	const callback = (message) => {
		dispatch(SyncPacmedProcessing({ fetchType: 'syncPacmedProcessing' }))
	};

	ablyConnectionManager.subscribe('pacmed-sync-channel', eventName, callback, subscriptionId);
	return createSubscriptionWrapper(subscriptionId);
}

export const subscribeAccountablityCounts = (pharmacyId,
	dispatch,
	setIsRefreshing
) => {
	if (!pharmacyId) {
		console.warn('No pharmacyId provided for Ably subscription');
		return null;
	}

	const channelName = `driver-accountability-count-channel-${pharmacyId}`;
	const channel = ablyConnectionManager.getChannel(channelName);
	if (!channel) return null;

	const channelID = `accountability-count-update-${pharmacyId}`;
	const subscriptionId = `${channelName}-${channelID}`;

	// Add a flag to track if we're already processing a message
	let isProcessing = false;

	const callback = (message) => {
		// Only process if we're not already processing a message
		if (!isProcessing) {
			isProcessing = true;

			if (typeof setIsRefreshing === 'function') {
				setIsRefreshing(true)
			}

			// Use Promise.resolve().then() to ensure the dispatch happens in the next microtask
			Promise.resolve().then(() => {
				dispatch(FetchTotalMissedRxCount())
				// Reset the processing flag after a short delay
				setTimeout(() => {
					isProcessing = false;
				}, 1000); // 1 second cooldown
			});
		}
	};

	ablyConnectionManager.subscribe(channelName, channelID, callback, subscriptionId);
	return createSubscriptionWrapper(subscriptionId);
}

// export const subscribeAccountabilityReports = (pharmacyId,
// 	dispatch,
// 	setDisabledDownload
// ) => {
// 	const ably = new Ably.Realtime({ key: apiKey, autoConnect: false });
// 	const channel = ably.channels.get(`accountability-report-pdf-${pharmacyId}`);
// 	const message = `report_generated_${pharmacyId}`
// 	ably.connect()
// 	channel.subscribe(message, (message) => {
// 		const report_id = message?.data?.report_id
// 		dispatch(GetAccountabilityFinalReport({
// 			fetchType: `downloadReport-${report_id}`,
// 			report_id: report_id
// 		})).finally(() => {
// 			if (typeof setDisabledDownload === 'function') {
// 				setDisabledDownload(null)
// 			}
// 		})
// 	})
// 	return ably
// }


export const subscribeAccountabilityReports = (pharmacyId,
	dispatch,
	setLoadingStates,
	handleFilterData,
	loginUserID
) => {
	if (!pharmacyId || !loginUserID) {
		console.warn('Missing pharmacyId or loginUserID for Ably subscription');
		return null;
	}

	const channelName = `accountability-report-pdf-${pharmacyId}-${loginUserID}`;
	const channel = ablyConnectionManager.getChannel(channelName);
	if (!channel) return null;

	const eventName = `report_generated_${pharmacyId}`;
	const subscriptionId = `${channelName}-${eventName}`;

	const callback = (message) => {
		const report_id = message?.data?.report_id
		const dates = message?.data?.dates
		dispatch(GetAccountabilityFinalReport({
			fetchType: `downloadReport-${report_id}`,
			report_id: report_id,
			dates: dates
		})).finally(() => {
			if (typeof setLoadingStates === 'function') {
				setLoadingStates(prev => ({ ...prev, [report_id]: false }));
			}
			if (typeof handleFilterData === 'function') handleFilterData()
		})
	};

	ablyConnectionManager.subscribe(channelName, eventName, callback, subscriptionId);
	return createSubscriptionWrapper(subscriptionId);
}


export const missedRxAcknNotifications = (pharmacyId,
	dispatch
) => {
	if (!pharmacyId) {
		console.warn('No pharmacyId provided for Ably subscription');
		return null;
	}

	const channelName = 'pharmacy-notifications';
	const channel = ablyConnectionManager.getChannel(channelName);
	if (!channel) return null;

	const eventName = `pharmacy-${pharmacyId}`;
	const subscriptionId = `${channelName}-${eventName}`;

	const callback = (message) => {
		const BilledCount = message?.data?.count
		const defaultType = message?.data?.actiontype
		if (message?.data?.type === 'acknowledgment_updated' && defaultType) {
			const actionMap = {
				'prep_but_not_billed': {
					type: actionTypes.NOT_BILLED_COUNT.SUCCESS,
					requestType: 'notBilledCount'
				},
				'wrong_prep': {
					type: actionTypes.WRONG_PREP_COUNT.SUCCESS,
					requestType: 'wrongPrepCount'
				},

				'missed_3x': {
					type: actionTypes.MISSED_3X_COUNT.SUCCESS,
					requestType: 'missed3xCount'
				},
				'missed_4x': {
					type: actionTypes.MISSED_4X_COUNT.SUCCESS,
					requestType: 'missed4xCount'
				}
			};

			if (actionMap[defaultType]) {
				dispatch(createAction(actionMap[defaultType].type, {
					data: BilledCount,
					requestType: actionMap[defaultType].requestType
				}));
			}
		}
	};

	ablyConnectionManager.subscribe('pharmacy-notifications', eventName, callback, subscriptionId);
	return createSubscriptionWrapper(subscriptionId);
}


export const medReviewFollowUp = (pharmacyId) => {
	if (!pharmacyId) {
		console.warn('No pharmacyId provided for Ably subscription');
		return null;
	}

	const channelName = `medreview-follow-new-review-${pharmacyId}`;
	const channel = ablyConnectionManager.getChannel(channelName);
	if (!channel) return null;

	const publishUrl = `medreview_notification`;
	const subscriptionId = `${channelName}-${publishUrl}`;

	const callback = (message) => {
		const patientName = message?.data?.patient_name
		const review_type = message?.data?.review_type
		const phn = message?.data?.phn
		let heading;
		let messageDisplay;
		let para;
		if (review_type === '90 Days') {
			heading = 'Follow - Up Reminder (Due Today)'
			messageDisplay = `MedReview follow - up due for ${patientName}`
			para = 'Please complete the review today.'
			MedReviewNotification(heading, messageDisplay, para, phn)
		}

		if (review_type === '365 Days') {
			heading = 'Overdue Review (Over 1 Year)'
			messageDisplay = `MedReview overdue for ${patientName}`
			para = 'Last review was over a year ago. Action required.'
			MedReviewNotification(heading, messageDisplay, para, phn)
		}
	};

	ablyConnectionManager.subscribe(channelName, publishUrl, callback, subscriptionId);
	return createSubscriptionWrapper(subscriptionId);
}

export const subscribePharmacyRouteRxUpdates = (pharmacyId, onRouteUpdate) => {
	if (!pharmacyId) {
		console.warn('No pharmacyId provided for Ably subscription');
		return null;
	}

	const channelName = `pharmacy-route-rx-updates-${pharmacyId}`;
	const channel = ablyConnectionManager.getChannel(channelName);
	if (!channel) return null;

	const eventName = 'route-rx-updated';
	const subscriptionId = `${channelName}-${eventName}`;

	const callback = (message) => {
		let response = message?.data;

		// Parse JSON string if response is a string
		if (typeof response === 'string') {
			response = JSON.parse(response);
		}

		// Call the callback if provided
		if (onRouteUpdate && typeof onRouteUpdate === 'function') {
			onRouteUpdate(response);
		}
	};

	ablyConnectionManager.subscribe(channelName, eventName, callback, subscriptionId);
	return createSubscriptionWrapper(subscriptionId);
}

export const subscribeBirthdayEvents = (pharmacyId, onEvent) => {
	if (!pharmacyId || typeof onEvent !== 'function') {
		console.warn('Missing pharmacyId or callback for birthday Ably subscription');
		return null;
	}

	const channelName = 'pharmacy-notifications';
	const channel = ablyConnectionManager.getChannel(channelName);
	if (!channel) return null;

	const eventName = `pharmacy-${pharmacyId}`;
	const subscriptionId = `${channelName}-${eventName}-birthday-module`;

	const callback = (message) => {
		if (message?.data?.module !== 'birthday' || !message?.data?.event) {
			return;
		}

		onEvent(message.data);
	};

	ablyConnectionManager.subscribe(channelName, eventName, callback, subscriptionId);
	return createSubscriptionWrapper(subscriptionId);
}

/**
 * MODULE ACCESS (module-permission revamp).
 *
 * An admin granting or revoking modules has to reach the people already logged
 * in — otherwise the nav they are looking at is whatever my-modules answered
 * when their tab was opened, possibly hours ago and possibly from before the
 * pharmacy was configured at all.
 *
 * Rides the SAME channel/event every other pharmacy-wide push uses
 * (`pharmacy-notifications` / `pharmacy-{id}`, published by App\Helpers\AblyHelper),
 * so no new realtime stack, no new channel to provision, no extra connection.
 * The payload is filtered on `type === 'module_access_updated'`, exactly how
 * the birthday and med-review subscribers filter this shared event.
 *
 * The callback is deliberately dumb: it only says "your answer is stale".
 * WHO refetches and WHAT the new gate allows stays with useMyModules, so there
 * is one source of truth and the realtime path cannot drift from the HTTP one.
 *
 * Delivery is pharmacy-wide because the event carries no recipient list: a
 * grant to one department changes the effective set of everyone in it, and the
 * server is the only thing that can say what each user now holds. One cheap GET
 * per open session, only when an admin actually saves.
 */
export const subscribeModuleAccessUpdates = (pharmacyId, onModuleAccessChanged) => {
	if (!pharmacyId || typeof onModuleAccessChanged !== 'function') {
		console.warn('Missing pharmacyId or callback for module-access Ably subscription');
		return null;
	}

	const CHANNEL_NAME = 'pharmacy-notifications';
	const channel = ablyConnectionManager.getChannel(CHANNEL_NAME);
	if (!channel) return null;

	const eventName = `pharmacy-${pharmacyId}`;
	// Suffixed so it cannot collide with the other subscribers on this same
	// channel+event (the manager keys its registry by this id).
	const subscriptionId = `${CHANNEL_NAME}-${eventName}-module-access`;

	const callback = (message) => {
		if (message?.data?.type !== 'module_access_updated') return;
		onModuleAccessChanged(message.data);
	};

	ablyConnectionManager.subscribe(CHANNEL_NAME, eventName, callback, subscriptionId);
	return createSubscriptionWrapper(subscriptionId);
}

export const subscribeMedReviewVisibility = (pharmacyId, dispatch) => {
	if (!pharmacyId) {
		console.warn('No pharmacyId provided for Ably subscription');
		return null;
	}

	const CHANNEL_NAME = 'pharmacy-notifications';
	const channel = ablyConnectionManager.getChannel(CHANNEL_NAME);
	if (!channel) return null;

	const eventName = `pharmacy-${pharmacyId}`;
	const subscriptionId = `${CHANNEL_NAME}-${eventName}`;

	const messageCallback = (message) => {
		// Only call CheckLogsExists API when the notification is specifically about med review logs visibility
		// Filter out acknowledgments - these should not trigger CheckLogsExists
		const messageType = message?.data?.type;

		// Exclude acknowledgment updates - these should not trigger CheckLogsExists
		if (messageType === 'acknowledgment_updated') {
			return;
		}

		// Only call CheckLogsExists for med review visibility related notifications
		// Check for specific med review visibility message types or data structure
		const isMedReviewVisibilityUpdate = messageType === 'med_review_logs_visibility' ||
			messageType === 'med_review_visibility' ||
			message?.data?.med_review_visibility !== undefined;

		if (isMedReviewVisibilityUpdate && dispatch && typeof dispatch === 'function') {
			dispatch(CheckLogsExists({
				fetchType: 'pharmacyNotifications'
			}));
		}
	};

	ablyConnectionManager.subscribe(CHANNEL_NAME, eventName, messageCallback, subscriptionId);
	return createSubscriptionWrapper(subscriptionId);
}

export const subscribeBirthdayNotifications = (pharmacyId, onBirthdayEvent) => {
	if (!pharmacyId || typeof onBirthdayEvent !== 'function') {
		return null;
	}

	const CHANNEL_NAME = 'pharmacy-notifications';
	const channel = ablyConnectionManager.getChannel(CHANNEL_NAME);
	if (!channel) return null;

	const eventName = `pharmacy-${pharmacyId}`;
	const subscriptionId = `${CHANNEL_NAME}-${eventName}-birthday`;

	const callback = (message) => {
		if (message?.data?.type !== 'birthday_wish_sent') {
			return;
		}

		onBirthdayEvent(message.data);
	};

	ablyConnectionManager.subscribe(CHANNEL_NAME, eventName, callback, subscriptionId);
	return createSubscriptionWrapper(subscriptionId);
}

export const investigateRxNotification = (pharmacyId, dispatch) => {
	if (!pharmacyId) {
		return null;
	}
	const CHANNEL_NAME = `investigate-rx-notifications-${pharmacyId}`;
	const channel = ablyConnectionManager.getChannel(CHANNEL_NAME);
	if (!channel) {
		return null;
	}

	const eventName = `new-investigate-rx`;
	const subscriptionId = `${CHANNEL_NAME}-${eventName}`;

	const messageCallback = async (message) => {
		// Call FetchNewRxList and wait for it to complete
		const result = await dispatch(FetchNewRxList({
			fetchType: 'fetchNewRxList',
			backgroundRefresh: true
		}));

		// Only call patient notifications API if FetchNewRxList succeeded
		if (result?.success) {
			// Call with backgroundRefresh flag, page 1, and default params
			dispatch(pharmacyTeamNotes.fetchPatientNotifications(
				1,  // page 1
				null,  // no setAddTeamNoteData
				{ marknotes: true },  // minimal addTeamNoteData with default marknotes
				null,  // no type
				'backgroundRefreshPatientNotifications',  // special type
				false,  // appendData = false
				true  // backgroundRefresh = true
			));
		}
	};

	ablyConnectionManager.subscribe(CHANNEL_NAME, eventName, messageCallback, subscriptionId);
	return createSubscriptionWrapper(subscriptionId);
}

export const MedReviewNotification = (heading, message, para, phn) => {
	toast(
		<div className="rounded-xl border w-full min-w-[420px] max-w-[420px] p-0 bg-white shadow-lg transform transition-all duration-200 ease-in-out hover:shadow-xl overflow-visible">
			<div className="relative">
				{/* Decorative Top Bar */}
				<div className="h-2 bg-gradient-to-r from-blue-500 to-purple-600 rounded-t-xl"></div>

				<div className="p-5 pr-10">
					{/* Close Button */}
					<button
						onClick={() => toast.dismiss()}
						className="absolute top-3 right-3 h-8 w-8 inline-flex items-center justify-center rounded-full hover:bg-gray-100 transition-colors duration-200"
						aria-label="Close"
					>
						<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="h-4 w-4 text-gray-500">
							<path d="M18 6 6 18"></path>
							<path d="m6 6 12 12"></path>
						</svg>
					</button>

					{/* Content */}
					<div className="space-y-4 min-w-0">
						{/* Header with Icon */}
						<div className="flex items-center gap-3 min-w-0">
							<div className="flex-shrink-0 p-2 rounded-full bg-blue-50">
								<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="h-5 w-5 text-blue-600">
									<path d="M12 22c5.523 0 10-4.477 10-10S17.523 2 12 2 2 6.477 2 12s4.477 10 10 10z"></path>
									<path d="m9 12 2 2 4-4"></path>
								</svg>
							</div>
							<div className="min-w-0 flex-1">
								<h3 className="font-bold text-gray-900 text-lg break-words">{heading}</h3>
							</div>
						</div>

						{/* Message Content */}
						<div className="bg-gray-50 rounded-lg p-2 min-w-0">
							<div className="space-y-1">
								<p className="text-gray-900 font-bold break-words">{message}</p>
								<p className="text-sm text-gray-600 break-words">{para}</p>
							</div>
						</div>
						{/* Action Button */}
						<button onClick={() => {
							window.open(`/pharmacy-patient-soap-notes?phn=${phn}&type=notified`, '_blank')
							toast.dismiss()
						}} className="w-full inline-flex items-center justify-center text-sm bg-gradient-to-r from-blue-600 to-purple-600 text-white hover:from-blue-700 hover:to-purple-700 h-11 rounded-lg px-4 font-medium transition-all duration-200 transform hover:scale-[1.02]">
							<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="h-4 w-4 mr-2">
								<path d="M21.801 10A10 10 0 1 1 17 3.335"></path>
								<path d="m9 11 3 3L22 4"></path>
							</svg>
							Review Now
						</button>
					</div>
				</div>
			</div>
		</div>
		,
		{
			containerId: "med-review",
			autoClose: false,
			hideProgressBar: true,
			closeOnClick: false,
			pauseOnHover: true,
			draggable: true,
			bodyClassName: 'gap-4',
			style: { background: "transparent", boxShadow: "none", padding: 0 }
		}
	)
}





